module.exports = __webpack_public_path__ + "img/splash.41637bb9.webp";